import { render, staticRenderFns } from "./appSidebar.vue?vue&type=template&id=1bf3b35c&scoped=true&"
import script from "./appSidebar.vue?vue&type=script&lang=js&"
export * from "./appSidebar.vue?vue&type=script&lang=js&"
import style0 from "./appSidebar.vue?vue&type=style&index=0&id=1bf3b35c&scoped=true&lang=css&"
import style1 from "./appSidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3b35c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VNavigationDrawer,VTooltip})
